import z from 'zod'
import { parseWithZod } from '../utils'
import { http } from './http'
import { DealCategorySchema, DealUsershipSchema } from '../schemas'
import { DealCategory } from '../types'

const DealCategoriesResponseSchema = z.object({
  deal_categories: z.array(DealCategorySchema),
})

const DealCategoryResponseSchema = z.object({
  deal_category: DealCategorySchema,
})

const BulkAssignResponseSchema = z.object({
  success: z.array(DealUsershipSchema),
  failed: z.array(z.object({ id: z.number(), errors: z.array(z.string()) })),
})

const regionUrl = (regionHost: string, path = '') =>
  `${location.protocol}//${regionHost}/api/deal_categories${path}`

export const dealCategories = {
  getAll: async (regionHost: string) => {
    const result = await http.get(regionUrl(regionHost))
    return parseWithZod(DealCategoriesResponseSchema, result).deal_categories
  },

  create: async (category: Pick<DealCategory, 'title' | 'type'>, regionHost: string) => {
    const result = await http.post(regionUrl(regionHost), category)
    return parseWithZod(DealCategoryResponseSchema, result).deal_category
  },

  editTitle: async (id: number, title: string, regionHost: string) => {
    const result = await http.post(regionUrl(regionHost, `/${id}/edit_title`), { title })
    return parseWithZod(DealCategoryResponseSchema, result).deal_category
  },

  remove: async (id: number, regionHost: string) => {
    await http.delete(regionUrl(regionHost, `/${id}`))
  },

  bulkAssign: async (
    payload: { deal_category_title: string; deal_usership_ids: number[] },
    regionHost: string,
  ) => {
    const result = await http.post(
      `${location.protocol}//${regionHost}/api/deal_userships/bulk_add_to_deal_category`,
      payload,
    )
    return parseWithZod(BulkAssignResponseSchema, result)
  },

  bulkAssignTemplates: async (
    payload: { deal_category_title: string; deal_template_ids: number[] },
    regionHost: string,
  ) => {
    const result = await http.post(
      `${location.protocol}//${regionHost}/api/deal_templates/bulk_add_to_deal_category`,
      payload,
    )
    return parseWithZod(BulkAssignResponseSchema, result)
  },
}
